// 首页
// mutations
export var RENDER_RECOMMEND_LIST = 'RENDER_RECOMMEND_LIST';
export var SORT_RECOMMEND_LIST = 'SORT_RECOMMEND_LIST';
export var MUTATE_PAGE_TO_INIT = 'MUTATE_PAGE_TO_INIT';
// actions
export var GET_BANNER_LIST = 'GET_BANNER_LIST';
export var RENDER_BANNER_LIST = 'RENDER_BANNER_LIST';
export var GET_RECOMMEND_LIST = 'GET_RECOMMEND_LIST';
export var GET_YELLOW_STRIP = 'GET_YELLOW_STRIP';
export var GET_NEXT_PAGE = 'GET_NEXT_PAGE';
export var NEXT_PAGE = 'NEXT_PAGE';
export var SELECT_SORT_TYPE = 'SELECT_SORT_TYPE';
export var CLICK_SORT_TYPE = 'CLICK_SORT_TYPE';
export var TOGGLE_SUB_SORT = 'TOGGLE_SUB_SORT';
export var CLOSE_SUB_SORT = 'CLOSE_SUB_SORT';
export var SELECT_SUB_TYPE = 'SELECT_SUB_TYPE';
export var SORT_SUB_TYPE = 'SORT_SUB_TYPE';
export var TOGGLE_LOADING_STATE = 'TOGGLE_LOADING_STATE';
export var CLICK_MASK = 'CLICK_MASK';
export var GET_HOTSHOP_LIST = 'GET_HOTSHOP_LIST';
export var RENDER_HOTSHOP_LIST = 'RENDER_HOTSHOP_LIST';
export var GET_BATCHFETCH_LIST = 'GET_BATCHFETCH_LIST';
export var RENDER_BATCHFETCH_LIST = 'RENDER_BATCHFETCH_LIST';
export var RENDER_YELLOW_STRIP = 'RENDER_YELLOW_STRIP';
export default {
  RENDER_RECOMMEND_LIST: RENDER_RECOMMEND_LIST,
  SORT_RECOMMEND_LIST: SORT_RECOMMEND_LIST,
  MUTATE_PAGE_TO_INIT: MUTATE_PAGE_TO_INIT,
  GET_BANNER_LIST: GET_BANNER_LIST,
  RENDER_BANNER_LIST: RENDER_BANNER_LIST,
  GET_RECOMMEND_LIST: GET_RECOMMEND_LIST,
  GET_YELLOW_STRIP: GET_YELLOW_STRIP,
  GET_NEXT_PAGE: GET_NEXT_PAGE,
  NEXT_PAGE: NEXT_PAGE,
  SELECT_SORT_TYPE: SELECT_SORT_TYPE,
  CLICK_SORT_TYPE: CLICK_SORT_TYPE,
  TOGGLE_SUB_SORT: TOGGLE_SUB_SORT,
  CLOSE_SUB_SORT: CLOSE_SUB_SORT,
  SELECT_SUB_TYPE: SELECT_SUB_TYPE,
  SORT_SUB_TYPE: SORT_SUB_TYPE,
  TOGGLE_LOADING_STATE: TOGGLE_LOADING_STATE,
  CLICK_MASK: CLICK_MASK,
  GET_HOTSHOP_LIST: GET_HOTSHOP_LIST,
  RENDER_HOTSHOP_LIST: RENDER_HOTSHOP_LIST,
  GET_BATCHFETCH_LIST: GET_BATCHFETCH_LIST,
  RENDER_BATCHFETCH_LIST: RENDER_BATCHFETCH_LIST,
  RENDER_YELLOW_STRIP: RENDER_YELLOW_STRIP
};